import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'

export class HoldAndWinActivateState extends BaseState {
    private static readonly TRIGGER_COIN_WIN_FALLBACK_MS = 2500
    private _isWaitingTriggerCoinWin: boolean = false
    private _fallbackTimeoutId: number | null = null

    public begin(): void {
        this._isWaitingTriggerCoinWin = true
        ;(GameSignals as any).holdAndWinTriggerCoinWinComplete?.connect(this.onTriggerCoinWinComplete)
        ;(GameSignals as any).holdAndWinTriggerCoinWinStart?.emit()

        this._fallbackTimeoutId = window.setTimeout(() => {
            this.onTriggerCoinWinComplete()
        }, HoldAndWinActivateState.TRIGGER_COIN_WIN_FALLBACK_MS)
    }

    private onTriggerCoinWinComplete = (): void => {
        if (!this._isWaitingTriggerCoinWin) {
            return
        }

        this._isWaitingTriggerCoinWin = false

        if (this._fallbackTimeoutId !== null) {
            window.clearTimeout(this._fallbackTimeoutId)
            this._fallbackTimeoutId = null
        }

        ;(GameSignals as any).holdAndWinTriggerCoinWinComplete?.disconnect(this.onTriggerCoinWinComplete)
        this.end()
    }

    public end = (): void => {
        this._stateMachine.setState(GameStatesEnum.HOLD_AND_WIN_INTRO_STATE)
    }

    public cleanUp(): void {
        this._isWaitingTriggerCoinWin = false

        if (this._fallbackTimeoutId !== null) {
            window.clearTimeout(this._fallbackTimeoutId)
            this._fallbackTimeoutId = null
        }

        ;(GameSignals as any).holdAndWinTriggerCoinWinComplete?.disconnect(this.onTriggerCoinWinComplete)
    }
}
